export enum QueryOperator {
	Equals,
	NotEquals,
	LargerThan,
	SmallerThan,
	Contains,
	LargerThanEquals,
	SmallerThanEquals
}